import React from "react"
import { Remarkable } from "remarkable"
import PropTypes from "prop-types"

export default class SharedMarkdown extends React.Component {
  render() {
    let Container = this.props.container

    return <Container>{this.content()}</Container>
  }

  componentDidUpdate(nextProps, nextState) {
    if (nextProps.options !== this.props.options) {
      this.md = new Remarkable(nextProps.options)
    }
  }

  content() {
    if (this.props.source) {
      return (
        <span
          dangerouslySetInnerHTML={{
            __html: this.renderMarkdown(this.props.source),
          }}
        />
      )
    } else {
      return React.Children.map(this.props.children, child => {
        if (typeof child === "string") {
          return (
            <span
              dangerouslySetInnerHTML={{ __html: this.renderMarkdown(child) }}
            />
          )
        } else {
          return child
        }
      })
    }
  }

  renderMarkdown(source) {
    if (!this.md) {
      this.md = new Remarkable(this.props.options)
    }

    return this.md.render(source)
  }
}

SharedMarkdown.propTypes = {
  container: PropTypes.string,
  options: PropTypes.any,
  source: PropTypes.string,
  children: PropTypes.any,
}

SharedMarkdown.defaultProps = {
  container: "div",
  options: {},
}
